// Angular
import { Component, ComponentFactoryResolver, OnDestroy } from '@angular/core';
import { BroadcastService, ModalService, ModalSize } from '@cv-invision/core';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CIJobTypesService } from '../service/ci-job-types.service';
import { CreateUpdateCIJobTypeComponent } from '../create-update-ci-job-type/create-update-ci-job-type.component';
import { DELETE_CI_JOB_TYPE } from '../model/ci-job-types.model';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
	selector: 'cv-ci-job-types-custom-action',
	templateUrl: './custom-action-ci-job-types-cell.component.html',
	styleUrls: ['./custom-action-ci-job-types-cell.component.scss']
})
export class CustomActionCIJobTypesCellComponent implements ICellRendererAngularComp, OnDestroy {
	private atComponentDestroy = new Subject();
	public cellValue: any;
	public index: any;

	constructor(
		private componentFactoryResolver: ComponentFactoryResolver,
		private broadcastService: BroadcastService,
		private modalService: ModalService,
		private ciJobTypesService: CIJobTypesService,
	) { }

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data;
		this.index = params.rowIndex;
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		this.index = params.rowIndex;
		return true;
	}

	/**
	 * Delete CI Job Types.
	 * @private
	 */
	onDeleteCIJobType(): void {
		this.modalService
			.customConfirm(
				'Delete CI Product',
				'Do you want to delete this CI Product?',
				'icon-warning fas fa-exclamation-circle',
				'Delete CI Product',
				'cv-btn-link-error'
			)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result.confirm === 'confirm') {
					this.broadcastService.broadcast({
						name: DELETE_CI_JOB_TYPE,
						event: {
							index: this.index,
							data: this.cellValue
						}
					});
				}
			});
	}

	/**
	 * Edit Mapper Lender Configuration
	 */
	onEditCIJobType(): void {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: CreateUpdateCIJobTypeComponent,
				data: {
					isEditing: true,
					ciJobTypeData: this.cellValue
				},
				modalConfiguration: {
					title: 'Edit CI Product Configuration',
					modalSize: ModalSize.XL
				}
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result.success) {
					this.ciJobTypesService.setReloadListConfirmation({
						reloadList: true
					});
				} else {
					// it failed :(
				}
			});
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
